// Randomize the color of product card title bubbles

const bubbles = document.querySelectorAll('.product-item .product-item__title span');

function shuffleArray(array){
  return array
    .map(value => ({ value, sort: Math.random() }))
    .sort((a, b) => a.sort - b.sort)
    .map(({ value }) => value)
}

if (bubbles && bubbles.length > 0) {
  const lightBubbles = ["#FFB555", "#E6E628", "#E2B1E5", "#C2DAE2", "#F26D65"];
  const darkBubbles = ["#127053", "#335DF1", "#5C2333"];
  const lightBubbleFont = "#003038";
  const darkBubbleFont = "#FFFFFF";
  
  let bubbleColors = lightBubbles.concat(darkBubbles);
   
  bubbles.forEach((bubble, index) => {
    const colorIndex = index % bubbleColors.length;
    if (colorIndex === 0) bubbleColors = shuffleArray(bubbleColors);
    const bubbleColor = bubbleColors[colorIndex];
    bubble.style.backgroundColor = bubbleColor;
    bubble.style.color = lightBubbles.includes(bubbleColor) ? lightBubbleFont : darkBubbleFont;
  });
}
